import styled from "styled-components";

export const ChangeLblContainer = styled.div<{
  isScratchedHorse?: boolean;
}>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;

  strong {
    color: ${({ theme }) => theme.colorTokens.content.warning};
    line-height: 18px;
  }

  ${({ isScratchedHorse }) =>
    !isScratchedHorse
      ? "margin-left: 16px; padding: 0 4px;"
      : "margin-left: 0;"};
`;

export const ChangesList = styled.div<{
  isFullWidth?: boolean;
  isSeeProfileAndPPModal?: boolean;
  expanded?: boolean;
  noExtraChanges?: boolean;
}>`
  width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "calc(100% - 24px)")};
  margin: ${({ isFullWidth }) => (isFullWidth ? "0" : "0 0 12px 12px")};
  list-style: none;
  background: ${({ theme }) => theme.colorTokens.background.accent};
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  border-radius: 4px;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  padding: 12px;
  margin-bottom: ${({ isSeeProfileAndPPModal }) =>
    isSeeProfileAndPPModal ? "0" : "12px"};
  ${({ expanded, noExtraChanges }) =>
    expanded || noExtraChanges
      ? `
          max-height: 1000px;
        `
      : `
          max-height: 100px;
          overflow: hidden;
        `}
  transition: max-height 200ms ease-in-out;
`;

export const List = styled.ol`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const Time = styled.time`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  line-height: 1.5;
  padding-right: 4px;
  white-space: nowrap;
`;

export const Dl = styled.dl`
  width: 100%;
  line-height: 1.5;
`;

export const Dt = styled.dt`
  display: flex;
  flex-wrap: nowrap;
  align-items: start;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const ScratchedHorse = styled.span`
  text-decoration: line-through;
`;

export const ChangesWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;
`;

export const ChangesTitle = styled.h3`
  color: ${({ theme }) => theme.colorTokens.content.default};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
`;

export const ShowAllChanges = styled.button`
  font-size: 12px;
  padding: 4px 8px;
  color: ${({ theme }) =>
    theme.colorTokens.component.button.buttonLink.content.base};
  font-weight: bold;
  background-color: transparent;
  outline: none;
  cursor: pointer;
`;
